module.exports = __webpack_public_path__ + "static/ses-2021-financial-statements-616031f7bf3490a35b84f63a589962b1.pdf";